import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseURL } from "../../Essentials/variables";

const dealersApi = createApi({
  reducerPath: "dealers",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseURL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("x-access-token", token);
      }
      headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
      headers.set("X-Frame-Options", "DENY");
      headers.set("Content-Security-Policy", "frame-ancestors 'none'");
      headers.set("Feature-Policy", "frame-ancestors 'none'");
      return headers;
    },
  }),
  endpoints: (builder) => {
    return {
      fetchDealers: builder.query({
        query: (data) => ({
          url: `/alldealers`,
          params: {
            id: data,
          },
          method: 'GET',
        }),
      }),
      updateDealer: builder.mutation({
        query: (data) => ({
          url: `/alldealers`,
          method: 'POST',
          body: {
            id: data?.id,
            mapAccess: data?.value,
            adminAccess: data?.admin,
            potentialAccess: data?.potential,
            change: data?.change,
            type: data?.Type,
            report:data?.report,
          },
        }),
      }),
    };
  },
});

export const { useFetchDealersQuery, useUpdateDealerMutation } = dealersApi;
export { dealersApi };